import { render, staticRenderFns } from "./FileTemplateName.vue?vue&type=template&id=36952d10&scoped=true"
import script from "./FileTemplateName.vue?vue&type=script&lang=js"
export * from "./FileTemplateName.vue?vue&type=script&lang=js"
import style0 from "./FileTemplateName.vue?vue&type=style&index=0&id=36952d10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36952d10",
  null
  
)

export default component.exports